<template>
  <BethsLayout :layoutTitle="`SafetyNet Alert`" :hasBuilding="true">
    <h1>
      SafetyNet Alert <br />
      <small> For AK SafetyNet</small>
    </h1>


    Your building is using the AK SafetyNet system to send out important life safetynet information. 
    This page is meant to help you understand how the alert system works and how to use it effectively.

    You can subscribe to receive alerts via email, SMS text messages, or Push Notifications.
    To subscribe, enter your contact information by clicking account settings in the top right corner of the page.

    When an alert is sent out, you will receive a message containing critical information about the situation, 
    such as the nature of the emergency, safety instructions, and any necessary actions you should take. 
    It is crucial to follow these instructions carefully to ensure your safety and the safety of those around you.


    </BethsLayout>
</template>